import { render, staticRenderFns } from "./ExerciseHistoryDialog.vue?vue&type=template&id=071494a4&scoped=true"
import script from "./ExerciseHistoryDialog.vue?vue&type=script&lang=js"
export * from "./ExerciseHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./ExerciseHistoryDialog.vue?vue&type=style&index=0&id=071494a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071494a4",
  null
  
)

export default component.exports